global.$ = require('jquery')
global.jQuery = $;
global.moment = require('moment-mini');
require('js-cookie');
require('tablednd');
global.signalR = require("@microsoft/signalr");
global.reactivity = {
	...require('@vue/reactivity')
};
global.Tango = {
	...require('Tango/tango/tango.errormsg.js'),
	...require('Tango/tango/tango.serializeForm.js'),
	...require('Tango/tango/tango.formatters.js')
};
require('Tango/tango/commonutils.js');
require('Tango/tango/observablearray.js');
require('Tango/tango/reactivetracker.js');
require('Tango/tango/domactions.js');
require('Tango/tango/tango.js');
require('Tango/tango/tango.component.js');
require('Tango/tango/contextmenuproxy.js');
require('Tango/tango/listview.js');
require('Tango/calendar/calendar_stripped.js');
require('Tango/calendar/calendarcontrol.js');
require('Tango/daterangepicker/daterangepicker.js');
require('Tango/tango/daterangepickerproxy.js');
require('Tango/tango/tabs.js');
require('Tango/contextmenu/contextmenu.js');
require('Tango/tango/dialog.js');
require('Tango/tango/selectdialog.js');
require('Tango/jquery/jquery.btnswitch.js');
require('Tango/tango/tangohub.js');